'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getKey(width, height, adProvider) {
  return width + '_' + height + '_' + adProvider;
}

/**
 * A simply lookup cache that stores display slots by their width, height and adProvider.
 * The cache exposes a .load() and a .getCompanionSlot() method to populate and retrieve
 * items from the cache.
 */

var CompanionCache = function () {
  function CompanionCache() {
    _classCallCheck(this, CompanionCache);

    this.displaySlotFormats = {};
    this.displaySlotIds = {};
  }

  _createClass(CompanionCache, [{
    key: 'reset',
    value: function reset() {
      this.displaySlotFormats = {};
      this.displaySlotIds = {};
    }
  }, {
    key: 'loadDisplaySlots',
    value: function loadDisplaySlots(slots) {
      var _this = this;

      (0, _forEach2.default)(slots, function (slot) {
        var elementId = slot.elementId,
            name = slot.name;

        _this.displaySlotIds[elementId] = elementId;

        (0, _forEach2.default)(slot.formats, function (format) {
          (0, _forEach2.default)(format.dimensions, function (dimension) {
            var key = getKey(dimension[0], dimension[1], format.adProvider);
            _this.displaySlotFormats[key] = { elementId: elementId, name: name, format: format };
          });
        });
      });
    }
  }, {
    key: 'getCompanionSlot',
    value: function getCompanionSlot(width, height, adProvider) {
      var key = getKey(width, height, adProvider);
      var slot = this.displaySlotFormats[key];
      if (!(0, _get2.default)(slot, 'format.isCompanion')) {
        return null;
      }
      return slot;
    }
  }, {
    key: 'removeDisplaySlot',
    value: function removeDisplaySlot(width, height, adProvider) {
      var key = getKey(width, height, adProvider);
      var slot = this.displaySlotFormats[key];
      var elementId = (0, _get2.default)(slot, 'elementId');
      if (!elementId) {
        return;
      }
      delete this.displaySlotFormats[key];
      delete this.displaySlotIds[elementId];
    }
  }]);

  return CompanionCache;
}();

exports.default = CompanionCache;